import React from 'react';
import { isImmutable } from 'immutable';

/* eslint-disable-next-line react/display-name */
const ImmutableConverter = (WrappedComponent) => (wrappedComponentProps) => {
  const KEY = 0;
  const VALUE = 1;

  const propsJS = Object.entries(wrappedComponentProps).reduce(
    (newProps, wrappedComponentProp) => {
      // eslint-disable-next-line no-param-reassign
      newProps[wrappedComponentProp[KEY]] = isImmutable(
        wrappedComponentProp[VALUE]
      )
        ? wrappedComponentProp[VALUE].toJS()
        : wrappedComponentProp[VALUE];
      return newProps;
    },
    {}
  );

  return <WrappedComponent {...propsJS} />;
};

export default ImmutableConverter;
